export class ConfigInjector<D = any> {
  data?: D;
}
